import { OrderAssignmentStatus } from '../../../providers';

import styles from './styles.module.scss';

export enum StatusIconVariant {
  Searching = 0,
  Waiting = 1,
  Confirmed = 2,
  Progress = 2,
  Done = 2,
}

export const ICON_VARIANT_MAP = {
  [OrderAssignmentStatus.Waiting]: StatusIconVariant.Waiting,
  [OrderAssignmentStatus.Confirmed]: StatusIconVariant.Confirmed,
  [OrderAssignmentStatus.Rejected]: StatusIconVariant.Searching,
  [OrderAssignmentStatus.AtWork]: StatusIconVariant.Progress,
  [OrderAssignmentStatus.Done]: StatusIconVariant.Done,
};

export const ASSIGNMENT_STATUS_ICON_CLASSES: Record<StatusIconVariant, string | string[]> = {
  [StatusIconVariant.Searching]: ['fas', 'fa-hourglass', styles.statusIconSearching],
  [StatusIconVariant.Waiting]: ['far', 'fa-circle-question', styles.statusIconWaiting],
  [StatusIconVariant.Confirmed]: ['fas', 'fa-circle-check', styles.statusIconConfirmed],
  [StatusIconVariant.Progress]: ['fas', 'fa-wrench', styles.statusIconWaiting],
  [StatusIconVariant.Done]: ['far', 'fa-clipboard-list-check', styles.statusIconConfirmed],
};
